<div #container
     class="container bg1 page-keyword {{ showDetail ? 'no-scroll' : '' }}"
     (scroll)="onScroll($event)">

  <app-example-header showJasoIdx="true"
                       placeholder="문장 듣기에서 검색 합니다."
                       [keyword]="keyword"
                       [keyHistory]="HISTORY_KEY_SEARCH_EXAMPLE"
                       (search)="onSearch($event)"></app-example-header>

  <app-left-menu></app-left-menu>

  <section class="keyword-data-list">
    <div class="inner wrap {{ showDetail ? 'detail-open' : '' }}">
      <article class="keyword-item-list">
        <div class="keyword-item-box"
             *ngIf="ll?.getTotalCount() === 0">
          <div class="img-box">
            <img src="assets/img/img_menu_tiger.svg">
          </div>
          <div class="keyword-no-result-box">
            {{ noResultTxt }}
          </div>
        </div>

        <app-example-list-item *ngFor="let example of ll?.getList(); let idx = index"
                               [example]="example"
                               [select]="showDetail && curDetail?.id === example.id"
                               class="keyword-item-box"
                               id="{{ exampleSelectId(example) }}"
                               attr.data-index="{{idx}}"
                               (click)="onSelectItem($event, example)"></app-example-list-item>

        <div class="reload-icon" *ngIf="ll?.getList() && !ll?.IsComplete()">
          <img #reload src="assets/img/loading_icon.gif">
        </div>
      </article>
    </div>
  </section>

  <app-example-detail *ngIf="showDetail" [@wordDetailInOut]
                      class="word-detail keyword-detail example-detail"
                      [example_id]="curDetail.id"
                      [height]="detailHeight"
                      [showHelpButton]="true"
                      (openExampleHelp)="OpenExampleHelp()"
                      (closeDetail)="onCloseItem()"></app-example-detail>

  <app-footer></app-footer>

  <article class="popup popup-help"
           *ngIf="lm.showExampleHelp">
    <app-example-help (closePopup)="CloseExampleHelp()"></app-example-help>
  </article>

</div>

<app-common-popups></app-common-popups>
